import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from '../../styles/styles.js';
import Typography from '../Typography.jsx';
const { makeStyles, useTheme } = styles;

const CardTitle = props => {
  const theme = useTheme();
  const titleColor = !props.titleColor || props.titleColor === 'primary'
    ?  theme.palette.primary.main
    : props.titleColor;
  const classes = useStyles({ titleColor });
  const { icon: Icon } = props;
  return (
    <div className={classNames(classes.root, props.className)}>
      <div className={classes.icon}>
        { Icon && <Icon height={26} width={24} fill={titleColor} /> }
      </div>
      <Typography variant={'h2'} className={classes.text} data-testid={props['data-testid']}>
        {props.children}
      </Typography>
    </div>
  );
};

const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-start',
    },
    icon: {
      marginRight: theme.spacing(2),
      display: 'flex',
    },
    text: ({ titleColor }) => ({
      color: titleColor,
      fontSize: 20,
      fontWeight: 500,
      lineHeight: 1.6,
      letterSpacing: '0.0075em',
    })
  })
);

CardTitle.propTypes = {
  icon: PropTypes.object,
  children: PropTypes.node,
  titleColor: PropTypes.oneOf(['primary', 'white', 'red']),
  'data-testid': PropTypes.string,
};

CardTitle.defaultProps = {
  icon: null,
  titleColor: 'primary',
};

export default CardTitle;
